// Piccolo modulo dentro la pagina del carrello (redesign 2026-10, fase 3):
// sostituisce i popup del browser per abbuono (importo + motivo) e nome zona.
// config: { title, fields: [{ id, label, type, defaultValue, placeholder, maxLength, step }],
//           confirmLabel, onConfirm(values) -> messaggio d'errore oppure null se va bene }
import React, { useEffect, useRef, useState } from 'react';

const CartDialog = ({ config, onClose, cancelLabel }) => {
  const [values, setValues] = useState(() =>
    Object.fromEntries((config?.fields || []).map((f) => [f.id, f.defaultValue ?? '']))
  );
  const [error, setError] = useState('');
  const firstRef = useRef(null);

  // onClose cambia a ogni aggiornamento della pagina: lo teniamo in un ref, così l'effetto sotto
  // non si ripete (prima riselezionava il testo a ogni lettera e si poteva scrivere un solo carattere).
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  // Solo all'apertura: cursore nel primo campo.
  useEffect(() => {
    firstRef.current?.focus();
    firstRef.current?.select?.();
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onCloseRef.current();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  if (!config) return null;

  const submit = (e) => {
    e.preventDefault();
    const err = config.onConfirm(values);
    if (err) {
      setError(err);
      return;
    }
    onClose();
  };

  return (
    <div className="c2-dialog-backdrop" onMouseDown={onClose}>
      <form
        className="c2-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="c2-dialog-title"
        onMouseDown={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <h3 id="c2-dialog-title">{config.title}</h3>
        {config.fields.map((f, i) => (
          <label key={f.id} className="c2-dialog-field" htmlFor={`c2d-${f.id}`}>
            <span>{f.label}</span>
            <input
              id={`c2d-${f.id}`}
              ref={i === 0 ? firstRef : undefined}
              type={f.type || 'text'}
              inputMode={f.type === 'number' ? 'decimal' : undefined}
              step={f.step}
              maxLength={f.maxLength}
              placeholder={f.placeholder}
              value={values[f.id]}
              onChange={(e) => {
                setError('');
                setValues((v) => ({ ...v, [f.id]: e.target.value }));
              }}
            />
          </label>
        ))}
        {error && <div className="c2-dialog-error" role="alert">{error}</div>}
        <div className="c2-dialog-actions">
          <button type="button" className="c2-btn" onClick={onClose}>{cancelLabel}</button>
          <button type="submit" className="c2-btn primary">{config.confirmLabel}</button>
        </div>
      </form>
    </div>
  );
};

export default CartDialog;
